import { darken } from '@material-ui/core/styles';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

export const StyledContainedButton = styled(Button)`
    ${({
        theme,
        $color,
        $backgroundColor,
        $width,
        $minWidth,
        $height,
        $noShadow,
        $disabledBackgroundColor,
        $icon,
        disabled,
    }) => `
  background-color: ${
      $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.primary.main
  };

  &:hover {
    background-color: ${
        $backgroundColor
            ? darken(theme.palette.common[$backgroundColor], 0.1)
            : darken(theme.palette.primary.main, 0.1)
    };
      }

  color: ${$color ? theme.palette.common[$color] : theme.palette.common.white};
  box-shadow: ${
      $noShadow ? 'none' : '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
  };
  text-transform: none;
  padding: 5px 24px;
  font-size: 16px;
  font-weight: 600;

  border-radius: 25px;
  height: ${$height ? $height : '32px'};
  width: ${$width ? $width : '100%'};
  min-width: ${$minWidth ? $minWidth : '0'};

  ${
      disabled
          ? `
  cursor:not-allowed;
  color: #fff;
  background-color: ${
      $disabledBackgroundColor ? $disabledBackgroundColor : theme.palette.common.gray7
  };
  `
          : ''
  };

  ${
      $icon
          ? `
    padding: 5px;
    height: ${$height ? $height : '32px'};
    width: ${$width ? $width : '32px'};
    min-width: 0;
    margin: 10px;
  `
          : ''
  }
  `}
`;

export const StyledOutlinedButton = styled(Button)`
    ${({
        theme,
        $backgroundColor,
        $color = 'primaryBlue',
        $height = '32px',
        $width = '100%',
        $noShadow,
        $borderWidth = '1px',
        $padding = '5px 24px',
    }) => `

    background-color: ${$backgroundColor ? theme.palette.common[$backgroundColor] : 'transparent'};

    color: ${theme.palette.common[$color]};
    
    // box-shadow: ${
        $noShadow ? 'none' : '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
    };
  text-transform: none;
  padding: ${$padding};
  font-size: 16px;
  font-weight: 600;

  border-radius: 25px;
  border: ${$borderWidth} solid ${theme.palette.common[$color]};
  height: ${$height};
  width: ${$width};

    `}
`;

export const StyledTextButton = styled(Typography)`
    ${({ theme, $color, disabled }) => `
    color: ${
        disabled
            ? theme.palette.common.gray4
            : $color
            ? theme.palette.common[$color]
            : theme.palette.common.gray1
    };
    font-size: 14px;
    cursor: ${disabled ? 'not-allowed' : 'pointer'};
  `}
`;

export const StyledRectangleButton = styled(Button)`
    ${({ theme, $noShadow }) => `
  background: linear-gradient(180deg, #FE5D83 0%, #F29BB0 100%);
  backdrop-filter: blur(4px);
  border-radius: 16px;
  color:${theme.palette.common.white};
  height: 48px;
  text-transform: none;
  box-shadow:${
      $noShadow
          ? 'none'
          : '0px 3px 1px -2px rgba(0,0,0,0.2),0px 2px 2px 0px rgba(0,0,0,0.14),0px 1px 5px 0px rgba(0,0,0,0.12)'
  };
  `}
`;
export const StyledGoBackButtonContainer = styled.div`
    display: flex;
    align-items: center;
    margin: 0 0 0 10px;
    cursor: pointer;
`;

export const StyledIconButton = styled(IconButton)`
    ${({ padding, margin, disabled }) => `
    padding: ${padding || 0};
    margin: ${margin || 0};
    width: 36px;
    height: 36px;
    cursor: ${disabled ? 'not-allowed' : 'pointer'} !important;
    pointer-events: auto !important;
    `}
`;

export const StyledFilledIconButton = styled(Button)`
    ${({ theme, $noShadow, $backgroundColor, $width, $height, $disabledBackgroundColor }) => `
    background-color: ${
        $backgroundColor ? theme.palette.common[$backgroundColor] : theme.palette.primary.main
    };
    &:hover {
      background-color: ${
          $backgroundColor
              ? darken(theme.palette.common[$backgroundColor], 0.1)
              : darken(theme.palette.primary.main, 0.1)
      };
        }
    box-shadow: ${
        $noShadow ? 'none' : '0 4px 6px rgba(50, 50, 93, 0.11), 0 1px 3px rgba(0, 0, 0, 0.08)'
    };
    min-width: 0;
    font-size: 16px;
    border-radius: 50%;
    height: ${$height ? $height : '32px'};
    width:  ${$width ? $width : '32px'};
    padding: 5px;
    margin: 10px;

    &:disabled{
        cursor:not-allowed;
        color: #fff;
        background-color: ${
            $disabledBackgroundColor
                ? theme.palette.common[$disabledBackgroundColor]
                : theme.palette.common.gray7
        };
      }

  `}
`;

export const StyledProfileMenuButton = styled(Button)`
    ${({ theme, $selected }) => `
    background: ${$selected ? theme.palette.common.dimBlue : theme.palette.common.tertiaryGradient};
    border: 1px solid ${theme.palette.common.white};
    box-sizing: border-box;
    backdrop-filter: blur(4px);
    border-radius: 16px;
    padding: 10px 20px;
    width: 100%;
    height: 55px;
    justify-content: flex-start;
  `}
`;
